<template>
    <div>
        <h3 v-if="type === 'todo'">Radiocarbon Reports</h3>
        
        <div class="row">
            <label v-if="type === 'search'" class="col-md-2 control-label text-label">Radiocarbon Reports</label>
            <div :class="{'col-md-10': (type === 'search'), 'wrapper': (type === 'todo'), 'col-md-12': (type === 'todo')}">
                <loader v-if="isLoading"></loader>
                <v-client-table :data="gridSpec.tableData" :columns="gridSpecColumns" :options="gridSpec.options">
                    <template slot="view" slot-scope="props">
                        <div style="text-align: center">
                            <a v-if="type === 'search'" class="fa fa-edit" style="font-size: 18px;" v-on:click="viewReport(props.row.radioCarbonReportId)"></a>
                            <!-- <a v-if="type === 'todo'" class="fa fa-edit" style="font-size: 18px;" v-on:click="viewTodo(props.row.culturalResourceRecordingId)"></a> -->
                            <router-link v-if="type === 'todo'" :to="{name: 'CulturalResourceRecording', params: {culturalResourceRecordingId: props.row.culturalResourceRecordingId, startAtTabIndex: 3}}" class="fa fa-edit" style="font-size: 18px;"></router-link>
                        </div>
                    </template>
                </v-client-table>
            </div>
        </div>
        <div>
            <modal ref="radioCarbonModal">
                <div slot="header" class="row">
                    <h3 class="pull-left">Radiocarbon Report</h3>
                    <button class="btn pull-right" v-on:click="closeRadioCarbonModel()">X</button>
                </div>
                <div slot="body">
                    <radioCarbonReport ref="radioCarbonReport" :formDisabled="crrId === null || formDisabled" 
                        :culturalResourceId="culturalResourceId" v-on:radioCarbonNewSave="radioCarbonNewSave"/>
                </div>
                <div slot="footer" style="display:none;">
                    <div class="row">
                        <button class="btn btn-primary col-md-1" type="button" name="cancel" v-on:click="closeRadioCarbonModel()">Close</button>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
import loggingService from '@/services/util/loggingService'
import radioCarbonReportService from '@/services/radioCarbonReportService'
import laboratoryService from '@/services/laboratoryService'
import radioCarbonReport from '@/components/RadioCarbonReport'
import modal from '@/components/Modal.vue'
import loader from '../components/Loader.vue'

export default {
    name: 'labResults',
    components: {
        radioCarbonReport: radioCarbonReport,
        modal: modal,
        loader: loader
    },
    data: function () {
        return {
            labList: [],
            isDebug: false,
            isLoading: true,
            gridSpec: {
                columns: ['view', 'workflowStatusDescription', 'mediaFilename', 'labCode', 'laboratoryRefNumber', 'measuredAge', 'reportDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        workflowStatusDescription: 'Status',
                        mediaFilename: 'File Name',
                        labCode: 'Lab Code',
                        laboratoryRefNumber: 'Lab Number',
                        measuredAge: 'Measured Age',
                        reportDate: 'Report Date'
                    },
                    dateColumns: ['reportDate'],
                    orderBy: {
                        ascending: false,
                        column: 'reportDate'
                    }
                }
            },
            newSaveEventName: 'radioCarbonNewSave'
        }
    },
    props: {
        loadOnMount: { default: true },
        culturalResourceId: { default: null },
        crrId: { default: null },
        formDisabled: { default: false },
        type: { default: 'search' }
    },
    computed: {
        gridSpecColumns: function () {
            if (this.culturalResourceId) {
                return ['view', 'mediaFilename', 'labCode', 'laboratoryRefNumber', 'measuredAge', 'reportDate']
            } else {
                return ['view', 'workflowStatusDescription', 'mediaFilename', 'labCode', 'laboratoryRefNumber', 'measuredAge', 'reportDate']
            }
        }
    },
    mounted () {
        if (this.loadOnMount) this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Production Lab Results', message)
        },
        loadLabList () {
            return laboratoryService.list(this.$http).then(result => {
                this.labList = result.data
                this.log('Found lab list: ' + this.labList.length)
                return result
            })
        },
        loadRadioCarbonReports () {
            var searchDto = {}
            if (this.type === 'search') {
                searchDto = {
                    culturalResourceId: this.culturalResourceId,
                    culturalResourceRecordingId: this.crrId
                }
                //search completed only if this is a site production component
                if (this.culturalResourceId) {
                    searchDto.completedOnly = true
                }
                return radioCarbonReportService.search(this.$http, searchDto).then(result => {
                    this.gridSpec.tableData = result.data.map(val => {
                        val.labCode = 'Unknown'
                        return val
                    })
                    return result
                })
            } else if (this.type === 'todo') {
                return radioCarbonReportService.todo(this.$http, searchDto).then(result => {
                    this.gridSpec.tableData = result.data.map(val => {
                        val.labCode = 'Unknown'
                        return val
                    })
                    return result
                })
            }
        },
        loadData () {
            this.isLoading = true
            Promise.all([this.loadLabList(), this.loadRadioCarbonReports()]).then(result => {
                this.gridSpec.tableData.forEach(x => {
                    var labMatch = this.labList.find(y => x.laboratoryId === y.laboratoryId)
                    if (labMatch) {
                        this.log('LabCode = ' + labMatch.labCode)
                        x.labCode = labMatch.labCode
                    }
                })
                this.isLoading = false
            })
        },
        viewReport (radioCarbonReportId) {
            this.$refs.radioCarbonReport.loadData(radioCarbonReportId)
            this.$refs.radioCarbonModal.open()
        },
        closeRadioCarbonModel () {
            this.$refs.radioCarbonReport.clearData()
            this.$refs.radioCarbonModal.close()
        },
        createNewReport (crrId) {
            this.$refs.radioCarbonReport.createNew(crrId)
            this.$refs.radioCarbonModal.open()
        },
        //passing the new Radio Carbon save to parent level
        radioCarbonNewSave (radioCarbonReportDto) {
            this.closeRadioCarbonModel()
            this.$emit(this.newSaveEventName, radioCarbonReportDto)
        },
        viewTodo (crrId) {
            this.$router.push({name: 'CulturalResourceRecording', params: {culturalResourceRecordingId: crrId, startAtTabIndex: 3}})
        }
    }
}
</script>



// WEBPACK FOOTER //
// LabResults.vue?f736973e